import { useMemo } from 'react';

export default function useInitilaValues({ policies }) {
  const initialValues = useMemo(() => {
    const policiesList = policies?.policies || [];

    let policiesIds = policiesList.reduce((acc, curr) => {
      acc[curr.policyType] = curr.id;
      return acc;
    }, {});

    let policyTypes = policiesList.map((item) => item.id && item.policyType);

    const getParam = (type, param) => policiesList.filter((item) => item?.policyType === type)[0]?.parameters?.[param] || null;

    return {
      file: '',
      policyTypes: policyTypes?.filter((item) => item !== null),
      policiesIds: policiesIds,
      policyParameters: {
        NUMBER_OF_ACCIDENTS_ALLOWED: getParam('DRIVER_SELECTION_MVR', 'NUMBER_OF_ACCIDENTS_ALLOWED'),
        NUMBER_OF_CITATIONS_ALLOWED: getParam('DRIVER_SELECTION_MVR', 'NUMBER_OF_CITATIONS_ALLOWED'),
        MIN_DRIVER_AGE: getParam('DRIVER_SELECTION_MVR', 'MIN_DRIVER_AGE'),
        MIN_YEARS_ON_SIMILAR_EQUIPMENT: getParam('DRIVER_SELECTION_MVR', 'MIN_YEARS_ON_SIMILAR_EQUIPMENT'),
        TRAINING_DAYS: getParam('DRIVER_SELECTION_MVR', 'TRAINING_DAYS'),
        MIN_HOURS: getParam('DRIVING_TRAINING', 'MIN_HOURS'),
        SAFETY_PERSON_FULL_NAME: getParam('DRIVING_TRAINING', 'SAFETY_PERSON_FULL_NAME'),
        ALLOW_USING_PHONES: !!getParam('DISTRACTION_FREE_DRIVING', 'ALLOW_USING_PHONES'),
      },
      DRESS_CODE: policyTypes?.includes('DRESS_CODE'),
      INSPECTION: policyTypes?.includes('INSPECTION'),
      PSP_USAGE: policyTypes?.includes('PSP_USAGE'),
      LOSS_CONTROL_MANUAL_POLICY: policyTypes?.includes('LOSS_CONTROL_MANUAL_POLICY'),
      DRIVER_SELECTION_MVR: policyTypes?.includes('DRIVER_SELECTION_MVR'),
      DRIVING_TRAINING: policyTypes?.includes('DRIVING_TRAINING'),
      ACCIDENT_INVESTIGATION: policyTypes?.includes('ACCIDENT_INVESTIGATION'),
      DISTRACTION_FREE_DRIVING: policyTypes?.includes('DISTRACTION_FREE_DRIVING'),
    };
  }, [policies]);

  return { initialValues };
}
